<wiz-hgroup width="100%" height="100%" class="section-container-parent" padding="5px">
  
  
  <wiz-vgroup width="200px" height="100%" class="section-container"><!-- zone champs libres & filtre -->
    <wiz-label [wizLabel]="'$.pivot.edit.field.all.$'" class="smallTitleLabel"></wiz-label>
    <wiz-list
      #freeList
      height="100%"
      width="100%"
      [wizItemRenderer]="renderer"
      id="freeList"
      [wizDataProvider]="dataSource"
      [wizLabelField]="'fullCode'"
      [dragEnabled]="true"
    ></wiz-list>
    <filter-component #mainFilter> </filter-component>
  </wiz-vgroup>

  <wiz-vgroup #vgDetailZone width="100%" height="100%">
    <!-- zone détail : poser les champs -->

    <wiz-list #lstGroup id="lstGroup" [visible]="false"></wiz-list> <!-- pas de groupes de colonnes -->
    <wiz-list #lstRow id="lstRow"[visible]="false"></wiz-list>  <!-- pas de lignes -->
    <wiz-list #lstColumn id="lstColumn"[visible]="false"></wiz-list>  <!-- pas de colonnes -->
    <wiz-list #lstData id="lstData"[visible]="false"></wiz-list>  <!-- pas de datas -->

    <wiz-vgroup [visible]="false" class="section-container"><!-- pas de zone contrôle d'intégrité -->     
      <wiz-checkbox #cbDeleteIntegrity [visible]="true" [wizLabel]="'$.pivot.edit.integrity.delete.$'"></wiz-checkbox>
      <wiz-list #lstIntegrity id="lstDeleteCheck" [visible]="false"></wiz-list>
      <wiz-checkbox #cbUpdateIntegrity [visible]="true" [wizLabel]="'$.pivot.edit.integrity.update.$'"></wiz-checkbox>
    </wiz-vgroup>

    <wiz-hgroup width="100%" height="100%"><!-- zone mesures & filters -->

        <wiz-vgroup width="100%" height="100%" minHeight="100px" class="section-container"><!-- champs filtres -->
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon class="image-purple">icon-filters</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.filter.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          <wiz-list
            #lstFilter
            id="lstFilter"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="renderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
            [dragMove]="true"
          ></wiz-list>
        </wiz-vgroup>
    </wiz-hgroup>

    <wiz-hgroup width="100%" [horizontalAlign]="'end'" verticalAlign="center" class="section-container">
      <wiz-vgroup width="100%" [visible]="!isToolMode">
        <wiz-checkbox #cbShowDeleteCol [wizLabel]="'$.pivot.edit.show.delete.$'" [visible]="false"></wiz-checkbox>
        <wiz-checkbox #cbShowDeleteRecurseCol [visible]="true" [wizLabel]="'$.pivot.edit.show.delete.recurse.$'" [visible]="false"></wiz-checkbox>
        <wiz-checkbox #cbShowSelectCol [wizLabel]="'$.pivot.edit.show.select.$'" [visible]="false"></wiz-checkbox>
        <wiz-checkbox #cbSelectUnique [visible]="false" [wizLabel]="'$.pivot.edit.show.select.$'"></wiz-checkbox>
      </wiz-vgroup>
      <wiz-button
        #btnSave
        width="150px"
        (click)="doValid()"
        [wizLabel]="'$.common.save.modification.$'"
        [wizIcon]="'icon-arrow-right'"
        [iconPlacement]="'right'"
      ></wiz-button>
      <wiz-button
        #btnCancel
        width="150px"
        (click)="doCancel()"
        class="cancel-button"
        [wizIcon]="'icon-arrow-left'"
        [wizLabel]="'$.common.cancel.modification.$'"
      ></wiz-button>
    </wiz-hgroup>
  </wiz-vgroup>
  <!-- fin zone détail -->
</wiz-hgroup>
